import React from "react";
import * as styles from "../styles/components/BrowserSupportError.css";
import ChromeIcon from "../assets/svg/browser/chrome_logo.svg";
import FirefoxIcon from "../assets/svg/browser/firefox_logo_icon.svg";
import IEIconDisabled from "../assets/svg/browser/ie_logo_disabled_grey.svg";
import SafariIcon from "../assets/svg/browser/safari_logo.svg";
import Icon from "./Icon";

const BrowserSupportError = () => (
    <div className={styles.container}>
        <div className={styles.content}>
            <h1 className={styles.header}>IE Not Supported</h1>
            <p className={styles.subheader}>
                Our platform does not currently support Internet Explorer.
                Please try another browser.
            </p>
            <div className={styles.supportStatus}>
                <div
                    className={[styles.browserSupportItem, styles.dis].join(
                        " "
                    )}
                >
                    <img
                        src={IEIconDisabled}
                        className={styles.browserIcon}
                        alt="ie"
                    />
                    <div
                        className={[
                            styles.supportIcon,
                            styles.unsupported
                        ].join(" ")}
                    >
                        <Icon icon="ban" />
                    </div>
                </div>
                <div className={styles.browserSupportItem}>
                    <img
                        src={ChromeIcon}
                        className={styles.browserIcon}
                        alt="chrome"
                    />
                    <div
                        className={[styles.supportIcon, styles.supported].join(
                            " "
                        )}
                    >
                        <Icon icon="check" />
                    </div>
                </div>
                <div className={styles.browserSupportItem}>
                    <img
                        src={FirefoxIcon}
                        className={styles.browserIcon}
                        alt="mozilla"
                    />
                    <div
                        className={[styles.supportIcon, styles.supported].join(
                            " "
                        )}
                    >
                        <Icon icon="check" />
                    </div>
                </div>
                <div className={styles.browserSupportItem}>
                    <img
                        src={SafariIcon}
                        className={styles.browserIcon}
                        alt="safari"
                    />
                    <div
                        className={[styles.supportIcon, styles.supported].join(
                            " "
                        )}
                    >
                        <Icon icon="check" />
                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <p className={styles.footerText}>
                    For additional help, please call us at (888) 835-6828 or
                    email{" "}
                    <a
                        href="mailto:support@wevoconversion.com"
                        className={styles.footerLink}
                    >
                        support@wevoconversion.com
                    </a>
                </p>
            </div>
        </div>
    </div>
);

export default BrowserSupportError;



// WEBPACK FOOTER //
// ./src/components/BrowserSupportError.js